import React, { useRef, useEffect, useState } from "react";
import CommonPage from "@icarius-common/commonPage";
import EditableGridv2 from "@icarius-common/editableGrid/editableGridv2";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    getAssetDiscountsBasicElementsFromServer,
    getAssetDiscountsGivenEntryStructureFromServer,
    setAssetDiscountsEntryPerConceptsToServer,
} from "../actions";
import {
    getEntryStructures,
    getLoading,
    getColumnTypes,
    getRows,
    getConceptsTypes,
    getConcepts,
    getSelects,
    getSocietyPeople,
    getColaborators,
    getCurrencyLocalization,
    getDateFormat,
    getQuantityPerUsedEntryStructure,
} from "../selectors";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import ConfirmationDialog from "./confirmationDialog";
import { getAppColor, getIsExportingGrid } from "@icarius-app/selectors";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import { exportDataGrid } from "devextreme/excel_exporter";
import { TextField, Grid, Select, MenuItem, FormControl, InputLabel, Button, Typography } from "@material-ui/core";
import UserSelectionDialogWithReplica from "./userSelectionDialogWithReplica";
import { createDateFromDDMMYYYY, formatDate } from "@icarius-utils/date";
import { AddIcon, FileCopyIcon, VisibilityIcon } from "@icarius-icons/";
import { useLocation } from "react-router-dom";
import useAutomaticProcesses from "@icarius-common/automaticProcesses/useAutomaticProcesses";
import ResultGridDialog from "@icarius-common/automaticProcesses/components/resultGridDialog";
import PickTemplateDialog from "@icarius-pages/employeesProcesses/components/dialogs/pickTemplateDialog";
import SelectProcessDialog from "@icarius-common/automaticProcesses/components/selectProcessDialog";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { formatNumberExactDecimals, formatNumberOrReturnUndefined } from "@icarius-utils/format";
import { RESET_STATE } from "../actionTypes";
import SecondGridDialog from "./secondGridDialog";
import NumberItem from "@icarius-pages/assetsDiscountsEntryPerConcept/components/numberItem";
import Autocomplete from "@material-ui/lab/Autocomplete";

const isObligatory = (value) => {
    return value === "B";
};

const gridStyle = { height: 100, padding: "0px 10px" };

const MassiveEntry = ({ history }) => {
    const mesesKeyValue = [
        { key: "1", value: getLocalizedString("january") },
        { key: "2", value: getLocalizedString("february") },
        { key: "3", value: getLocalizedString("march") },
        { key: "4", value: getLocalizedString("april") },
        { key: "5", value: getLocalizedString("may") },
        { key: "6", value: getLocalizedString("june") },
        { key: "7", value: getLocalizedString("july") },
        { key: "8", value: getLocalizedString("august") },
        { key: "9", value: getLocalizedString("september") },
        { key: "10", value: getLocalizedString("october") },
        { key: "11", value: getLocalizedString("november") },
        { key: "12", value: getLocalizedString("december") },
    ];

    const arrayIsNumber = [
        "Valor informado bruto",
        "Valor informado líquido",
        "Cantidad",
        "Porcentaje",
        "Base de cálculo",
    ];

    const meses = mesesKeyValue.map((mes) => mes.value);

    const location = useLocation();

    const [userSelectionDialogIsOpen, setUserSelectionDialogIsOpen] = useState(false);
    const [selectedConcept, setSelectedConcept] = useState(null);
    const [selectedEntryStructureCode, setSelectedEntryStructureCode] = useState(location?.state?.structureKey || "");
    const [dataChanged, setDataChanged] = useState(false);
    const [shouldReloadGrid, setShouldReloadGrid] = useState(false);
    const [confirmationDialogIsOpen, setConfirmationDialogIsOpen] = useState(false);
    const [gridReference, setGridReference] = useState(null);
    const [secondGridDialogIsOpen, setSecondGridDialogIsOpen] = useState(false);
    const [rowDataToReplicate, setRowDataToReplicate] = useState(null);
    const [isAddingRows, setIsAddingRows] = useState(false);
    const rowData = useSelector(getRows);
    const entryStructures = useSelector(getEntryStructures);
    const columnTypes = useSelector(getColumnTypes);
    const conceptsTypes = useSelector(getConceptsTypes);
    const concepts = useSelector(getConcepts);
    const selects = useSelector(getSelects);
    const isLoading = useSelector(getLoading);
    const societyPeople = useSelector(getSocietyPeople);
    const colaborators = useSelector(getColaborators);
    const locale = useSelector(getCurrencyLocalization);
    const dateFormat = useSelector(getDateFormat);
    const quantityPerUsedEntryStructure = useSelector(getQuantityPerUsedEntryStructure);
    const color = useSelector(getAppColor);
    const isExportinGrid = useSelector(getIsExportingGrid);

    const {
        isExecution,
        automaticProcessesIsLoading,
        automaticProcessesIsEnabled,
        processList,
        resultData,
        resultDialogIsOpen,
        pickTemplateDialogIsOpen,
        processSelectionDialogIsOpen,
        executeProcess,
        handleExecute,
        viewResult,
        handleViewResult,
        handleCloseProcessDialogSelection,
        handleCloseResultDialog,
        handleOpenPickTemplateDialog,
        handleClosePickTemplateDialog,
        handleGenerateDocumentsGivenTemplate,
    } = useAutomaticProcesses(paths.calculateProcessAssetsDiscountsButton);

    const gridRef = useRef();

    const dispatch = useDispatch();

    let allConcepts = [];
    conceptsTypes.forEach((el) =>
        allConcepts.push(...concepts[el.value].map((concept) => ({ ...concept, "Tipo de concepto": el.key })))
    );
    allConcepts = allConcepts.sort((a, b) => a.value.localeCompare(b.value)); //Ordeno alfabeticamente

    useEffect(() => {
        dispatch(getAssetDiscountsBasicElementsFromServer("MAS"));
    }, [dispatch]);

    useEffect(() => {
        if (selectedEntryStructureCode !== "") {
            dispatch(getAssetDiscountsGivenEntryStructureFromServer("MAS", selectedEntryStructureCode)).then((resp) => {
                if (resp.statusText === "OK") {
                    setShouldReloadGrid(true);
                }
            });
        }
    }, [dispatch, selectedEntryStructureCode, gridReference]);

    useEffect(() => {
        if (selectedEntryStructureCode !== "" && gridRef) {
            setGridReference(gridRef.current);
        }
    }, [gridRef, selectedEntryStructureCode]);

    const handleSave = () => {
        let ds = gridReference.getDataSource();
        let filter = gridReference.getCombinedFilter();
        gridReference.saveEditData().done((resp) => {
            ds.store()
                .load({ sort: ds.sort(), filter: filter ? filter : null })
                .done((allData) => {
                    const rowData = allData;

                    gridReference
                        .getController("validating")
                        .validate(true)
                        .then((isValid) => {
                            if (isValid) {
                                let formattedData = rowData.map((row) => {
                                    let modifiedRow = { ...row };

                                    for (let [key, value] of Object.entries(modifiedRow)) {
                                        if (key.includes("(hhmm)")) {
                                            let newKey = key.replace("(hhmm)", "(hh:mm)");
                                            delete modifiedRow[key];
                                            modifiedRow[newKey] = value;

                                            let arr = value.split(":");
                                            let dec = parseInt((arr[1] / 6) * 10, 10);

                                            let newValue = parseFloat(
                                                parseInt(arr[0], 10) + "." + (dec < 10 ? "0" : "") + dec
                                            );

                                            modifiedRow["Cantidad"] = formatNumberExactDecimals(newValue, 5);
                                        }
                                    }
                                    return modifiedRow;
                                });

                                formatDataBeforeServerRequest(formattedData);
                            } else {
                                dispatch(
                                    openSnackbarAction({
                                        msg: getLocalizedString("verifyThatCellsHaveValidValues"),
                                        severity: "error",
                                    })
                                );
                            }
                        });
                });
        });
    };

    const formatDataBeforeServerRequest = (data) => {
        // Aca arranco a poner lo que hace falta
        const entryStructure = getEntryStructure();

        let filteredData = data.filter((row) => row["Concepto"]);
        let formattedData = filteredData.map((row) => {
            let modifiedRow = { ...row };

            // Periodicidad
            if (entryStructure.periodicity === "U") {
                modifiedRow["En fecha"] = formatDate(row["En fecha"]);
            }

            if (entryStructure.advancePayment) {
                modifiedRow["Fecha de descuento"] = formatDate(row["Fecha de descuento"]);
            }

            delete modifiedRow["Fecha de contratación"];
            delete modifiedRow["Fecha de egreso"];

            // Tengo que formatear los valores numericos con punto en vez de coma
            if (row["Valor informado líquido"]) {
                modifiedRow["Valor informado líquido"] = row["Valor informado líquido"]
                    .replace(/\./g, "")
                    .replace(/,/g, ".");
            }

            if (row["Valor informado bruto"]) {
                modifiedRow["Valor informado bruto"] = row["Valor informado bruto"]
                    .replace(/\./g, "")
                    .replace(/,/g, ".");
            }

            if (row["Cantidad"]) {
                modifiedRow["Cantidad"] = row["Cantidad"].replace(/\./g, "").replace(/,/g, ".");
            }

            if (row["Porcentaje"]) {
                modifiedRow["Porcentaje"] = row["Porcentaje"].replace(/\./g, "").replace(/,/g, ".");
            }

            if (row["Base de cálculo"]) {
                modifiedRow["Base de cálculo"] = row["Base de cálculo"].replace(/\./g, "").replace(/,/g, ".");
            }

            modifiedRow["Periodicidad"] = entryStructure.periodicity;

            for (let [key, value] of Object.entries(modifiedRow)) {
                if (key.includes("(hhmm)")) {
                    delete modifiedRow[key];
                    let newKey = key.replace("(hhmm)", "(hh:mm)");
                    modifiedRow[newKey] = value;
                }
            }

            return modifiedRow;
        });

        sendDataToServer(selectedEntryStructureCode, formattedData);
    };

    const sendDataToServer = (selectedEntryStructureCode, formattedData) => {
        dispatch(
            setAssetDiscountsEntryPerConceptsToServer({
                type: "MAS",
                entryStructure: selectedEntryStructureCode,
                items: formattedData,
            })
        ).then((resp) => {
            gridReference.getScrollable().scrollTo(0);

            //limpiar el seleccionado
            gridReference.deselectAll();

            if (resp?.response?.data?.status === "DUPLICATED_DATA") {
                const rowsToSelect = [];
                resp.response.data.codes.forEach((element) => {
                    gridReference.getVisibleRows().forEach((node) => {
                        if (
                            Number(node.data.type) === Number(element.type) &&
                            Number(node.data.seniorityFrom) === Number(element.seniorityFrom) &&
                            Number(node.data.seniorityTo) === Number(element.seniorityTo) &&
                            Number(node.data.additionalDays) === Number(element.additionalDays) &&
                            Number(node.data.lawDays) === Number(element.lawDays)
                        ) {
                            rowsToSelect.push(node.key);
                        }
                    });

                    gridReference.selectRows(rowsToSelect);
                });
            } else {
                setShouldReloadGrid(true);
            }

            if (resp?.status === 200) {
                setDataChanged(false);
            }
        });
    };

    const handleOpenDeleteDialog = () => {
        // Me fijo cuantas filas seleccionadas tengo
        let selectedRows = gridReference.getSelectedRowsData();

        // Si no hay seleccionado, pido seleccionar
        if (selectedRows.length < 1) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRow"), severity: "warning" }));
            return;
        }

        dispatch(
            openDialogAction({
                title: getLocalizedString("atention"),
                msg: getLocalizedString("doYouWantToDeleteSelectedRows"),
                onConfirm: () => deleteRowsLocally(selectedRows),
            })
        );
    };

    const deleteRowsLocally = (rowsToDelete) => {
        gridReference.cancelEditData();
        if (Array.isArray(rowsToDelete)) {
            const ds = gridReference.getDataSource();
            const filter = gridReference.getCombinedFilter();
            ds.store()
                .load({ sort: ds.sort(), filter: filter ? filter : null })
                .done((allData) => {
                    const rowData = allData;
                    rowsToDelete.forEach((row) => {
                        const filteredRows = rowData.filter((el) => JSON.stringify(el) === JSON.stringify(row));
                        filteredRows.forEach((gridRow) =>
                            gridReference
                                .getDataSource()
                                .store()
                                .remove(gridRow)
                                .then(() => {
                                    gridReference.refresh();
                                })
                        );
                    });
                });
        }
        dispatch(openSnackbarAction({ msg: getLocalizedString("valuesDeletedSuccessfully"), severity: "success" }));
    };

    const handleGoBack = () => {
        dispatch({ type: RESET_STATE });
        history.push(paths.assetsDiscounts);
    };

    const handleCheckGoBack = () => {
        if (dataChanged) {
            setConfirmationDialogIsOpen(true);
        } else {
            if (location?.state?.from) {
                history.push(paths.assetsDiscountsSummary);
            } else {
                handleGoBack();
            }
        }
    };

    const handleExportGrid = () => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet(getLocalizedString("assetsAndDiscountsScreenSelector"));

        exportDataGrid({
            component: gridReference,
            worksheet,
            autoFilterEnabled: true,
            customizeCell: ({ gridCell, excelCell }) => {
                if (gridCell.value) {
                    if (gridCell.rowType === "data") {
                        if (arrayIsNumber.includes(gridCell.column.dataField) && Boolean(gridCell.value)) {
                            excelCell.value = Number(gridCell.value.replace(/\./g, "").replace(/,/g, "."));
                            excelCell.numFmt = "_(###0.00_);_((###0.00)";
                        }
                    }
                }
            },
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(
                    new Blob([buffer], { type: "application/octet-stream" }),
                    `${getLocalizedString("assetsAndDiscountsScreenSelector")} - ${getLocalizedString(
                        "massEntry"
                    )}.xlsx`
                );
            });
        });
    };

    const handleValidateAndExecute = () => {
        let selectedRows = gridReference.getSelectedRowsData();
        if (selectedRows.length < 1) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRow"), severity: "warning" }));
            return;
        }

        const employeeCodes = selectedRows.map((item) => item["Código de empleado"]);
        handleExecute(employeeCodes);
    };

    const executeItem = () =>
        automaticProcessesIsEnabled && (
            <CustomIconButton
                title={
                    processList.length === 1
                        ? `${getLocalizedString("calculateProcess")}: ${processList[0].value}`
                        : getLocalizedString("calculateProcess")
                }
                onClick={handleValidateAndExecute}
                type={"execute"}
            />
        );

    const handleValidateAndViewResult = () => {
        let selectedRows = gridReference.getSelectedRowsData();
        if (selectedRows.length !== 1) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOnlyOneRow"), severity: "warning" }));
            return;
        }

        handleViewResult(selectedRows[0], selectedRows[0]["Código de empleado"]);
    };

    const viewResultItem = () =>
        automaticProcessesIsEnabled && (
            <CustomIconButton title={getLocalizedString("viewResult")} onClick={handleValidateAndViewResult}>
                <VisibilityIcon />
            </CustomIconButton>
        );

    const saveItem = () => <CustomIconButton title={getLocalizedString("save")} onClick={handleSave} type={"save"} />;

    const deleteItem = () => (
        <CustomIconButton title={getLocalizedString("delete")} onClick={handleOpenDeleteDialog} type={"delete"} />
    );

    const goBackButton = () => (
        <CustomIconButton title={getLocalizedString("goBack")} onClick={handleCheckGoBack} type={"goBack"} />
    );

    const exportGrid = () => (
        <CustomIconButton title={getLocalizedString("exportData")} onClick={handleExportGrid} type={"excel"} />
    );

    const selectDataSources = (name, data) => {
        if (meses.includes(name)) {
            return [
                { key: "N", value: "No" },
                { key: "Y", value: "Si" },
            ];
        }
        switch (name) {
            case "Meses a reliquidar":
                const mesesReliquidacion = [];
                for (let i = 1; i <= 36; i++) {
                    mesesReliquidacion.push({ key: `${i}`, value: `${i}` });
                }
                return mesesReliquidacion;
            case "Tipo de concepto":
                return conceptsTypes;
            case "Indicador de cálculo":
                return selects.calculationIndicators;
            case "Código de referencia":
                return selects.codeRefs;
            case "Proyecto":
                return selects.projects;
            case "Banco":
                return selects.banks;
            case "Forma de pago":
                return selects.paymentMethods;
            case "Tercero":
                return selects.thirdParties;
            case "Tipo de pago":
                return selects.paymentTypes;
            case "Centro de costo":
            case "Centro de costo 3":
            case "Centro de costo 4":
            case "Centro de costo 5":
                return selects.benefitCenters;
            case "Centro de costo 2":
                return selects.benefitCenters;
            case "Concepto":
                const element = conceptsTypes.find((el) => el.key === data);
                if (element && element.value) {
                    return concepts[element.value];
                }
                return [];
            case "all-concepts":
                let testArr = [];
                conceptsTypes.forEach((el) =>
                    testArr.push(...concepts[el.value].map((concept) => ({ ...concept, "Tipo de concepto": el.key })))
                );
                return testArr;
            default:
                return [];
        }
    };

    const formattedData = rowData.map((originalRow) => {
        let row = { ...originalRow };

        if (row["Cantidad"]) {
            row["Cantidad"] = formatNumberOrReturnUndefined(row["Cantidad"], 0, 5);
        }

        if (row["Valor informado líquido"]) {
            row["Valor informado líquido"] = formatNumberOrReturnUndefined(row["Valor informado líquido"], 0, 2);
        }

        if (row["Valor informado bruto"]) {
            row["Valor informado bruto"] = formatNumberOrReturnUndefined(row["Valor informado bruto"], 0, 2);
        }

        if (row["Porcentaje"]) {
            row["Porcentaje"] = formatNumberOrReturnUndefined(row["Porcentaje"], 0, 2);
        }

        if (row["Base de cálculo"]) {
            row["Base de cálculo"] = formatNumberOrReturnUndefined(row["Base de cálculo"], 0, 2);
        }

        for (let [key, value] of Object.entries(row)) {
            if (key.includes("(hh:mm)")) {
                delete row[key];
                let newKey = key.replace("(hh:mm)", "(hhmm)");
                row[newKey] = value;
            }
        }

        return row;
    });

    const getEntryStructure = () => {
        const entryStructure = entryStructures.find((entry) => entry.code === selectedEntryStructureCode);
        return entryStructure || { periodicity: "" };
    };

    const getColaboratorData = (employeeCode) => {
        return colaborators.find((colaborator) => colaborator["CODIGO DE EMPLEADO"] === employeeCode);
    };

    const generateColumns = () => {
        // Primero, tengo las columnas fijas
        let columns = [];
        columns.push({
            headerName: getLocalizedString("code"),
            field: "Código de empleado",
            isObligatory: true,
            disabled: true,
            maxLength: 254,
            minLength: 0,
            isFixed: true,
        });

        columns.push({
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellido y nombres",
            isObligatory: true,
            maxLength: 254,
            minLength: 0,
            isFixed: true,
            disabled: true,
        });

        columns.push({
            field: "Fecha de contratación",
            headerName: getLocalizedString("incomeDate"),
            cellEditor: "dateEditor",
            filter: "agTextColumnFilter",
            isDate: true,
            dataType: "date",
            disabled: true,
            visible: false,
        });

        columns.push({
            field: "Fecha de egreso",
            headerName: getLocalizedString("outcomeDate"),
            cellEditor: "dateEditor",
            filter: "agTextColumnFilter",
            isDate: true,
            dataType: "date",
            disabled: true,
            visible: false,
        });

        columns.push({
            field: "Tipo de concepto",
            headerName: getLocalizedString("conceptType"),
            isObligatory: true,
            isSelect: true,
        });

        columns.push({
            headerName: getLocalizedString("employeesProcessConcepto"),
            field: "Concepto",
            isObligatory: true,
            isSelect: true,
        });

        columns.push({
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: "Nombre del concepto",
            isObligatory: true,
            maxLength: 254,
            minLength: 0,
        });

        // Aca arranco a poner lo que hace falta
        const entryStructure = getEntryStructure();

        // Periodicidad
        switch (entryStructure.periodicity) {
            case "U": // En fecha especifica
                columns.push({
                    field: "En fecha",
                    headerName: getLocalizedString("onDate"),
                    cellEditor: "dateEditor",
                    filter: "agTextColumnFilter",
                    isDate: true,
                    dataType: "date",
                    isObligatory: true,
                });
                break;
            case "T": // Temporal (Desde y hasta)
                columns.push({
                    field: "Período desde",
                    headerName: getLocalizedString("periodFrom"),
                    isObligatory: true,
                });
                columns.push({
                    field: "Período hasta",
                    headerName: getLocalizedString("periodUntil"),
                    isObligatory: true,
                });
                break;
            case "M": // En meses específicos
                meses.forEach((mes) =>
                    columns.push({
                        headerName: mes,
                        field: mes,
                        isObligatory: true,
                        isSelect: true,
                    })
                );
                break;
            default:
                break;
        }

        // Horas y Minutos
        if (entryStructure.hoursMinutes) {
            columns.push({
                field: "Horas y Minutos (hhmm)",
                headerName: getLocalizedString("hoursAndMinutesHhmmColon"),
                isObligatory: isObligatory(entryStructure.hoursMinutes),
                maxLength: 254,
                minLength: 0,
            });
        }

        // Cantidad
        if (entryStructure.quantity) {
            columns.push({
                headerName: getLocalizedString("employeesProcessAmount"),
                field: "Cantidad",
                isObligatory: isObligatory(entryStructure.quantity),
                maxLength: 254,
                minLength: 0,
                isNumeric: true,
                validationUnrequired: true,
            });
        }

        // Valor informado
        if (entryStructure.informedValue) {
            if (entryStructure.informedValueType === "L") {
                columns.push({
                    headerName: getLocalizedString("liquidReportedValue"),
                    field: "Valor informado líquido",
                    isObligatory: isObligatory(entryStructure.informedValue),
                    maxLength: 254,
                    minLength: 0,
                    isNumeric: true,
                    validationUnrequired: true,
                });
            } else {
                columns.push({
                    headerName: getLocalizedString("grossReportedValue"),
                    field: "Valor informado bruto",
                    isObligatory: isObligatory(entryStructure.informedValue),
                    maxLength: 254,
                    minLength: 0,
                    isNumeric: true,
                    validationUnrequired: true,
                });
            }
        }

        // Porcentaje
        if (entryStructure.percentage) {
            columns.push({
                headerName: getLocalizedString("employeesProcessPorcentaje"),
                field: "Porcentaje",
                isObligatory: isObligatory(entryStructure.percentage),
                maxLength: 254,
                minLength: 0,
                isNumeric: true,
                validationUnrequired: true,
            });
        }

        // Base de calculo
        if (entryStructure.calculationBase) {
            columns.push({
                headerName: getLocalizedString("employeesProcessBaseCalculo"),
                field: "Base de cálculo",
                isObligatory: isObligatory(entryStructure.calculationBase),
                maxLength: 254,
                minLength: 0,
                isNumeric: true,
                validationUnrequired: true,
            });
        }

        // Datos para reliquidación - Período de reliquidación - Meses a reliquidar
        if (entryStructure.reliquidation) {
            columns.push({
                headerName: getLocalizedString("employeesProcessPeriodoReliquidacion"),
                field: "Período de reliquidación",
                isObligatory: isObligatory(entryStructure.reliquidation),
                maxLength: 254,
                minLength: 0,
            });

            columns.push({
                headerName: getLocalizedString("employeesProcessMesesReliquidar"),
                field: "Meses a reliquidar",
                isObligatory: isObligatory(entryStructure.reliquidation),
                isSelect: true,
            });
        }

        // Honorarios - Número de comprobante
        if (entryStructure.honoraries) {
            columns.push({
                headerName: getLocalizedString("employeesProcessNumeroComprobante"),
                field: "Número de comprobante",
                isObligatory: isObligatory(entryStructure.honoraries),
                maxLength: 254,
                minLength: 0,
            });
        }

        // Pago a terceros
        if (entryStructure.thirdPartyPayment) {
            columns.push({
                headerName: getLocalizedString("thirdPartySingular"),
                field: "Tercero",
                isObligatory: isObligatory(entryStructure.thirdPartyPayment),
                isSelect: true,
            });
            columns.push({
                headerName: getLocalizedString("paymentMethod"),
                field: "Forma de pago",
                isObligatory: isObligatory(entryStructure.thirdPartyPayment),
                isSelect: true,
            });
            columns.push({
                headerName: getLocalizedString("paymentType"),
                field: "Tipo de pago",
                isObligatory: isObligatory(entryStructure.thirdPartyPayment),
                isSelect: true,
            });
            columns.push({
                headerName: getLocalizedString("bank"),
                field: "Banco",
                isObligatory: false,
                isSelect: true,
            });

            columns.push({
                headerName: getLocalizedString("bankAccount"),
                field: "Cuenta bancaria",
                isObligatory: false,
                maxLength: 254,
                minLength: 0,
            });

            columns.push({
                field: "Comentarios del pago al tercero",
                headerName: getLocalizedString("paymentToThirdPartyComments"),
                isObligatory: false,
                maxLength: 254,
                minLength: 0,
            });
        }

        // Periodo de imputacion
        if (entryStructure.imputationPeriod) {
            columns.push({
                field: "Periodo de imputación",
                headerName: getLocalizedString("accountingPeriod"),
                isObligatory: isObligatory(entryStructure.imputationPeriod),
                maxLength: 254,
                minLength: 0,
            });
        }

        // Centro de costo
        if (entryStructure.benefitCenter) {
            columns.push({
                field: "Centro de costo",
                headerName: getLocalizedString("employeesProcessCentroBeneficio"),
                isObligatory: isObligatory(entryStructure.benefitCenter),
                isSelect: true,
            });
        }

        // Centro de costo 2
        if (entryStructure.benefitCenter2) {
            columns.push({
                field: "Centro de costo 2",
                headerName: getLocalizedString("costCenter2"),
                isObligatory: isObligatory(entryStructure.benefitCenter2),
                isSelect: true,
            });
        }

        // Centro de costo 3
        if (entryStructure.benefitCenter3) {
            columns.push({
                field: "Centro de costo 3",
                headerName: getLocalizedString("costCenter3"),
                isObligatory: isObligatory(entryStructure.benefitCenter3),
                isSelect: true,
            });
        }

        // Centro de costo 4
        if (entryStructure.benefitCenter4) {
            columns.push({
                field: "Centro de costo 4",
                headerName: getLocalizedString("costCenter4"),
                isObligatory: isObligatory(entryStructure.benefitCenter4),
                isSelect: true,
            });
        }

        // Centro de costo 5
        if (entryStructure.benefitCenter5) {
            columns.push({
                field: "Centro de costo 5",
                headerName: getLocalizedString("costCenter5"),
                isObligatory: isObligatory(entryStructure.benefitCenter5),
                isSelect: true,
            });
        }

        // Proyecto
        if (entryStructure.project) {
            columns.push({
                headerName: getLocalizedString("employeesProcessProyecto"),
                field: "Proyecto",
                isObligatory: isObligatory(entryStructure.project),
                isSelect: true,
            });
        }

        // Código de referencia
        if (entryStructure.codeRef) {
            columns.push({
                field: "Código de referencia",
                headerName: getLocalizedString("employeesProcessCodigoReferencia"),
                isObligatory: Boolean(entryStructure.codeRef),
                isSelect: true,
            });
        }

        // Anticipo - Fecha de descuento
        if (entryStructure.advancePayment) {
            columns.push({
                field: "Fecha de descuento",
                headerName: getLocalizedString("discountDate"),
                cellEditor: "dateEditor",
                filter: "agTextColumnFilter",
                isDate: true,
                dataType: "date",
                isObligatory: isObligatory(entryStructure.advancePayment),
            });
        }

        // Indicador de cálculo
        if (entryStructure.calculationIndicator) {
            columns.push({
                field: "Indicador de cálculo",
                headerName: getLocalizedString("calculationIndicator"),
                isObligatory: Boolean(entryStructure.calculationIndicator),
                isSelect: true,
            });
        }

        columns.push({
            headerName: getLocalizedString("employeesProcessComentarios"),
            field: "Comentarios",
            maxLength: 254,
            minLength: 0,
        });

        return columns;
    };

    const handleSetUsers = (values, replicate) => {
        setIsAddingRows(true);
        values.forEach((colab, index) => {
            const fullColaboradorData = colaborators.find((colaborator) => colaborator["CODIGO DE EMPLEADO"] === colab);

            const dataSource = gridReference.getDataSource();

            let data = {};
            if (replicate) {
                data = { ...rowDataToReplicate[0] };
            }

            data["Código de empleado"] = fullColaboradorData["CODIGO DE EMPLEADO"];
            data["Apellido y nombres"] = fullColaboradorData["APELLIDO Y NOMBRE"];
            data["Fecha de contratación"] = fullColaboradorData["FECHA DE INGRESO"]
                ? createDateFromDDMMYYYY(fullColaboradorData["FECHA DE INGRESO"])
                : null;
            data["Fecha de egreso"] = fullColaboradorData["FECHA DE EGRESO"]
                ? createDateFromDDMMYYYY(fullColaboradorData["FECHA DE EGRESO"])
                : null;

            dataSource
                .store()
                .insert(data)
                .then(function() {
                    dataSource.reload();
                    if (index + 1 === values.length) {
                        setTimeout(() => setIsAddingRows(false), 100);
                    }
                });
        });
    };

    const onChangeEntryStructure = (entryStructure) => {
        setSelectedEntryStructureCode(entryStructure);
        setRowDataToReplicate(null);
        setSelectedConcept(null);
        if (gridReference) {
            gridReference.getScrollable().scrollTo(0);
        }
    };

    let customItems = [goBackButton];

    if (selectedEntryStructureCode !== "") {
        customItems = [...customItems, saveItem, exportGrid, executeItem, viewResultItem, deleteItem];
    }

    const usedEntryStructures = quantityPerUsedEntryStructure.map((structure) => structure.code);

    const copyDataToReplicate = () => {
        if (rowDataToReplicate) {
            setRowDataToReplicate(null);
        } else {
            // Me fijo cuantas filas seleccionadas tengo
            let selectedRows = gridReference.getSelectedRowsData();

            // Si no hay seleccionado, pido seleccionar
            if (selectedRows.length === 0) {
                dispatch(openSnackbarAction({ msg: getLocalizedString("youMustSelectARow"), severity: "warning" }));
                return;
            } else if (selectedRows.length > 1) {
                dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOnlyOneRow"), severity: "warning" }));
                return;
            }

            gridReference.saveEditData().done((resp) => setRowDataToReplicate(selectedRows));
        }
    };

    useEffect(() => {
        rowData && setShouldReloadGrid(true);
    }, [rowData]);

    return (
        <CommonPage
            title={`${getLocalizedString("assetsAndDiscountsScreenSelector")} - ${getLocalizedString("massEntry")}`}
            menuItems={customItems}
            isLoading={isLoading || automaticProcessesIsLoading || isAddingRows}
            isNotGridPage
        >
            <Grid container item alignItems="center" xs={12} style={{ paddingLeft: 5 }}>
                {selectedEntryStructureCode !== "" && (
                    <Grid container item alignItems="center" justify="flex-end" style={{ padding: "0px 10px" }} xs={12}>
                        <Grid container item xs={12} justify="flex-end">
                            <Button
                                startIcon={<FileCopyIcon htmlColor={rowDataToReplicate ? "#FFFFFF" : color} />}
                                className="whiteText"
                                onClick={copyDataToReplicate}
                                variant="contained"
                                style={{
                                    marginRight: 10,
                                    backgroundColor: rowDataToReplicate ? "red" : "var(--secondaryBackgroundColor)",
                                    border: "1px solid var(--borderColor)",
                                }}
                            >
                                {rowDataToReplicate
                                    ? getLocalizedString("clearCopiedData")
                                    : getLocalizedString("copyDataToReplicate")}
                            </Button>
                            <Button
                                startIcon={<AddIcon htmlColor={color} />}
                                className="whiteText"
                                onClick={() => setUserSelectionDialogIsOpen(true)}
                                variant="contained"
                                style={{
                                    marginRight: 10,
                                    backgroundColor: "var(--secondaryBackgroundColor)",
                                    border: "1px solid var(--borderColor)",
                                }}
                            >
                                {getLocalizedString("collaborator")}
                            </Button>
                            <Button
                                startIcon={<AddIcon htmlColor={color} />}
                                className="whiteText"
                                onClick={() => setSecondGridDialogIsOpen(true)}
                                variant="contained"
                                style={{
                                    marginRight: 20,
                                    backgroundColor: "var(--secondaryBackgroundColor)",
                                    border: "1px solid var(--borderColor)",
                                }}
                            >
                                {getLocalizedString("collaboratorList")}
                            </Button>
                        </Grid>
                    </Grid>
                )}
                <Grid container item alignItems="center" xs={12}>
                    <Grid container item alignItems="center" style={gridStyle} xs={3}>
                        <FormControl style={{ width: "100%" }}>
                            <InputLabel>{getLocalizedString("filterEstructura de ingreso")}</InputLabel>
                            <Select
                                value={selectedEntryStructureCode}
                                onChange={(e) => onChangeEntryStructure(e.target.value)}
                                margin={"none"}
                            >
                                {entryStructures &&
                                    entryStructures.map((item) => (
                                        <MenuItem
                                            className={"whiteText"}
                                            key={item.code}
                                            disabled={usedEntryStructures.includes(item.code)}
                                            value={item.code}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid container item alignItems="center" style={gridStyle} xs={3}>
                        <TextField
                            disabled
                            fullWidth
                            margin={"none"}
                            label={getLocalizedString("periodicity")}
                            value={
                                selectedEntryStructureCode && Boolean(columnTypes.length)
                                    ? columnTypes?.find((el) => el.key === getEntryStructure()?.periodicity).value
                                    : ""
                            }
                            inputProps={{ maxLength: 8 }}
                        />
                    </Grid>
                    <Grid container item alignItems="center" xs={3}>
                        <Autocomplete
                            disabled={!selectedEntryStructureCode || allConcepts.length === 0}
                            style={{ width: "100%" }}
                            options={allConcepts}
                            value={selectedConcept}
                            onChange={(event, selectedConcept) => {
                                setSelectedConcept(selectedConcept);

                                let rowsToSelect = [];

                                gridReference.getVisibleRows().forEach((node) => {
                                    if (node.data["Concepto"] === selectedConcept?.key) {
                                        rowsToSelect.push(node.key);
                                    }
                                });

                                gridReference.selectRows(rowsToSelect);
                                if (rowsToSelect.length > 0) {
                                    gridReference.navigateToRow(rowsToSelect[0]).then(() => {
                                        const rowElement = gridReference.getRowElement(
                                            gridReference.getRowIndexByKey(rowsToSelect[0])
                                        );
                                        if (rowElement) {
                                            rowElement[0].scrollIntoView({
                                                behavior: "smooth",
                                                block: "center",
                                            });
                                        }
                                    });
                                }
                            }}
                            clearOnBlur
                            clearText={getLocalizedString("clear")}
                            noOptionsText={""}
                            getOptionLabel={(data) => data?.value || data}
                            renderInput={(params) => <TextField {...params} label={getLocalizedString("concept")} />}
                        />
                    </Grid>
                </Grid>
            </Grid>
            {quantityPerUsedEntryStructure.length > 0 && (
                <Grid container item xs={12} style={{ margin: 10, marginTop: 0 }} spacing={2}>
                    {quantityPerUsedEntryStructure.map((el, index) => (
                        <Grid item key={index}>
                            <NumberItem
                                name={el.name}
                                value={el.cant}
                                selected={el.code === selectedEntryStructureCode}
                                onClick={() => onChangeEntryStructure(el.code)}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}
            {selectedEntryStructureCode !== "" && (
                <EditableGridv2
                    batchMode={true}
                    selectDataSources={selectDataSources}
                    setShouldReloadGrid={setShouldReloadGrid}
                    shouldReloadGrid={shouldReloadGrid}
                    setDataChanged={setDataChanged}
                    ref={gridRef}
                    gridName={"massEntry"}
                    rowData={formattedData}
                    columns={generateColumns()}
                    getColaboratorData={getColaboratorData}
                />
            )}
            {selectedEntryStructureCode === "" && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <Grid container alignItems="center" justify="center" direction="column" style={{ marginTop: 150 }}>
                        <Typography
                            color="textSecondary"
                            className="whiteText"
                            variant="h2"
                            style={{ fontSize: 32, fontWeight: 700, marginBottom: 16 }}
                        >
                            {getLocalizedString("selectAnIncomeStructure")}
                        </Typography>
                    </Grid>
                </Grid>
            )}
            {confirmationDialogIsOpen && (
                <ConfirmationDialog
                    open={confirmationDialogIsOpen}
                    handleConfirm={handleGoBack}
                    handleClose={() => setConfirmationDialogIsOpen(false)}
                />
            )}
            {userSelectionDialogIsOpen && (
                <UserSelectionDialogWithReplica
                    open={userSelectionDialogIsOpen}
                    users={societyPeople}
                    title={getLocalizedString("addCollaborator")}
                    selectedUsersTitle={getLocalizedString("selectedEmployees")}
                    isDataReplicateDisabled={rowDataToReplicate === null}
                    handleSubmit={(values, replicate) => handleSetUsers(values, replicate)}
                    handleClose={() => setUserSelectionDialogIsOpen(false)}
                />
            )}
            {secondGridDialogIsOpen && !isLoading && (
                <SecondGridDialog
                    open={secondGridDialogIsOpen}
                    data={colaborators}
                    dateFormat={dateFormat}
                    locale={locale}
                    isDataReplicateDisabled={rowDataToReplicate === null}
                    handleConfirm={handleSetUsers}
                    handleClose={() => setSecondGridDialogIsOpen(false)}
                />
            )}
            {processSelectionDialogIsOpen && (
                <SelectProcessDialog
                    open={processSelectionDialogIsOpen}
                    title={
                        isExecution
                            ? getLocalizedString("selectProcessToRun")
                            : getLocalizedString("selectProcessToQuery")
                    }
                    processList={processList}
                    handleClose={handleCloseProcessDialogSelection}
                    handleExecute={isExecution ? executeProcess : viewResult}
                />
            )}
            {resultDialogIsOpen && !(isLoading || automaticProcessesIsLoading) && !isExportinGrid && (
                <ResultGridDialog
                    open={resultDialogIsOpen}
                    templates={resultData.templates}
                    process={resultData.process}
                    employeeName={resultData.employee["Apellido y nombres"]}
                    handleClose={handleCloseResultDialog}
                    handleOpenPickTemplateDialog={handleOpenPickTemplateDialog}
                    handleGenerateDocumentsGivenTemplate={handleGenerateDocumentsGivenTemplate}
                />
            )}
            {resultData?.templates?.length > 0 &&
                pickTemplateDialogIsOpen &&
                !(isLoading || automaticProcessesIsLoading) &&
                !isExportinGrid && (
                    <PickTemplateDialog
                        open={pickTemplateDialogIsOpen}
                        templates={resultData.templates}
                        handleConfirm={handleGenerateDocumentsGivenTemplate}
                        handleClose={handleClosePickTemplateDialog}
                    />
                )}
        </CommonPage>
    );
};

export default MassiveEntry;
